import BaseLink from '@eversports/react-components/primitives/BaseLink'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { Localized } from '../../../localization/react'
interface Props {
  url: string
}

const PrivacyPolicy: React.FC<React.PropsWithChildren<Props>> = ({ url }) => (
  <BaseLink to={url} external blank>
    <Text color="primary.main" fontWeight="bold" is="span">
      <Localized id="additional-info-policies-privacy-policy" />
    </Text>
  </BaseLink>
)

export default PrivacyPolicy
